// Pink theme - DEFAULT (free)
const pink = {
  id: 'pink',
  name: 'Pinkki',
  price: 0,
  main: '#E040A0',
  light: '#FF80C3',
  dark: '#ff80c4',
  bg: '#fde7ff',
  darkBg: '#190622',
  isSuper: false,
  surfaces: {
    // Light mode (rgba over blurred light backdrop)
    lightBg: '#f4cdff',
    lightPaper: '#fde7ff',
    lightContainer: '#fde7ff',
    lightOnSurface: '#1a1a2e',
    lightOnSurfaceVariant: '#704f7d',
    lightOutline: '#9165a1',
    // Dark mode (rgba over blurred dark backdrop)
   // Dark mode
    containerLowest: '#290c36',
    containerLow: '#20082b',
    container: '#290c36',
    containerHigh: '#321040',
    containerHighest: '#3b134b',
    bright: '#441757',
    onSurface: '#f9dcff',
    onSurfaceVariant: '#ca9ada',
    outline: '#9165a1',
    outlineVariant: '#603770',
    // Button colors — primary
    primaryContainer: '#fa56b6',
    onPrimaryContainer: '#350021',
    primaryText: '#fde7ff',
    primaryTextLight: '#fde7ff',
    // Button colors — secondary (outlined)
    secondaryContainer: '#380665',
    onSecondaryContainer: '#bd90ee',
    // Button colors — secondary (filled)
    secondary: '#dbb8ff',
    onSecondary: '#542a81',
    secondaryLight: '#7c52aa',
    onSecondaryLight: '#380665',
    // Button colors — inverse
    inverseSurface: '#fff7fb',
    onInverseSurface: '#654c6d',
    inverseSurfaceLight: '#190622',
    onInverseSurfaceLight: '#f9dcff',
    // Button colors — label/text
    labelColor: '#ff70bf',
    labelColorLight: '#b3117b',
    // Status colors
    success: '#4caf50',
    successLight: '#81c784',
    successDark: '#2e7d32',
    warning: '#ed6c02',
    warningLight: '#ff9800',
    warningDark: '#e65100',
    error: '#fd6f85',
    errorLight: '#ff97a3',
    errorDark: '#8a1632',
  },
};

export default pink;
